import React from 'react'
import FaqPortal from "@Features/faq/components/FaqPortal";
import datasetParser from "@Dataset/datasetParser";
import CompanyReviewPortal, {COMPANY_REVIEW_PORTAL_ID} from "./CompanyReviewPortal";
import ErrorBoundary from "@Errors/components/ErrorBoundary";
import {isEmpty} from "@Array/isEmpty";
import CompanyReviewType from "@Pages/companyProfile/types/CompanyReview.type";
import ReviewsPortal from "@Pages/reviewWidget/components/ReviewsPortal";
import TableOfContentsPortal from "@Features/tableOfContents/components/TableOfContentsPortal";
import toggleStaticMainContentElements from "@Features/domElements/functions/toggleStaticMainContentElements";

const CompanyProfilePortal = () => {
    let companyReviews: CompanyReviewType[];
    toggleStaticMainContentElements(true)
    try {
        const data = datasetParser({id: COMPANY_REVIEW_PORTAL_ID})

        companyReviews = data.companyReviews
    } catch (e) { // if element not found on
        companyReviews = [];
    }

    return (
        <>
            <ErrorBoundary shouldReload={false}>
                {!isEmpty(companyReviews) && (
                    <CompanyReviewPortal
                        companyReviews={companyReviews}
                    />
                )}
                <ReviewsPortal/>
            </ErrorBoundary>
            <FaqPortal/>
            {window.tableOfContents && (<TableOfContentsPortal/>)}
        </>
    )
}

export default CompanyProfilePortal